import { Icon, Text, TextLink } from '@oneaudi/unified-web-components';
import { useI18n } from '~/app/i18n/i18n';
import { useMarketConfig } from '~/app/market-config';
import {
	ListItemStyle,
	ListStyle,
	TyreLabelStyle,
} from '~/app/pages/configurator/components/dialogs/car-matching-results-dialog/styles/tyre-label-styles';
import { ConfiguredCarFeature } from '~/graphql/__generated__/graphql';

export function EuTyreLabel({ tyreLabels }: { tyreLabels: NonNullable<ConfiguredCarFeature['tyreLabels']> }) {
	const { i18n } = useI18n();
	const { config } = useMarketConfig();

	return (
		<TyreLabelStyle>
			{config.euTyreLink && (
				<>
					<Text variant={{ type: 'copy', order: '1', style: 'bold' }}>
						{i18n('ngc.dialogs.euTyreLabel.linkText')}
					</Text>

					<TextLink
						variant="standalone"
						href={config.euTyreLink}
						size="md"
						target="_blank"
						iconPosition={'trailing'}
						icon={'forward'}>
						{i18n('ngc.dialogs.euTyreLabel.linkText')}
					</TextLink>
				</>
			)}
			<section className="flex flex-row gap-4 bg-grey-5 p-4">
				<Icon name={'info-circle'} size="s" />
				<Text variant={{ type: 'copy', order: '1', style: 'normal' }}>
					{i18n('ngc.dialogs.euTyreLabel.disclaimer')}
				</Text>
			</section>

			{tyreLabels.length > 0 && (
				<ListStyle>
					{tyreLabels.map((label) => (
						<ListItemStyle key={label?.productSheetUrl}>
							{label?.tyreLabelUrl && (
								<img className="h-80 object-scale-down" src={label.tyreLabelUrl} alt="EU Tyre Label" />
							)}
							{label?.productSheetUrl && (
								<TextLink
									size="md"
									variant="standalone"
									href={label.productSheetUrl}
									target="_blank"
									iconPosition={'trailing'}
									icon={'forward'}>
									{i18n('ngc.actions.productDataSheet')}
								</TextLink>
							)}
						</ListItemStyle>
					))}
				</ListStyle>
			)}
		</TyreLabelStyle>
	);
}
